import { createAction, props } from '@ngrx/store';
import { Document } from 'src/app/modules/core/store/models';

import { Layer, LayerTypes } from '../cop/models';
import {
  ClosestAssetCountByLayer,
  ClosestAssetFilterDto,
  ClosestAssetCountResponse,
  DocumentSummaryByLayer,
  DocumentSummaryWithEmail
} from './impacted-assets.model';

export const calculateSelectedDocumentAssetsSummary = createAction(
  '[Impacted Assets] Calculate Selected Document Assets Summary',
  props<{
    document?: Document;
    layer?: Layer;
    shape?: GeoJSON.Feature[];
    withinMeters?: number;
    visibleOnly?: boolean;
    layersOfType?: LayerTypes[];
    forEvent?: 'selection';
  }>()
);
export const requestClosestAssetCounts = createAction(
  '[Impacted Assets] Closest Asset Counts Api Call',
  props<{ closesetAssetDto: ClosestAssetFilterDto; forEvent?: 'selection' }>()
);
export const requestClosestAssetCountsComplete = createAction(
  '[Impacted Assets] Closest Asset Counts Api Call Complete',
  props<{ results: ClosestAssetCountResponse[]; forEvent?: 'selection' }>()
);
export const setClosestAssetCounts = createAction(
  '[Impacted Assets] Set Selected Document Assets Counts Complete',
  props<{ countsByLayer: ClosestAssetCountByLayer[]; isControlShown: boolean }>()
);
export const setClosestAssetRequest = createAction(
  '[Impacted Assets] Set Selected Document Assets Count Meta',
  props<{ closestAssetDto: ClosestAssetFilterDto; forEvent?: 'selection' }>()
);
export const requestUnloadedClosestAssets = createAction(
  '[Impacted Assets] Get Unloaded Closest Asset Api Call',
  props<{ layerUIds: string[] }>()
);
export const requestClosestAssetsByLayer = createAction('[Impacted Assets] Closest Asset By Layer Api Call', props<{ layerUId: string }>());
export const requestClosestAssets = createAction(
  '[Impacted Assets] Closest Asset Api Call',
  props<{ closestAssetDto: ClosestAssetFilterDto; forEvent?: 'selection' }>()
);
export const setClosestAsset = createAction(
  '[Impacted Assets] Set Closest Asset Data for layer',
  props<{ docs: Document[]; forEvent?: 'selection' }>()
);
export const setClosestIsWorking = createAction('[Impacted Assets] Set Closest Assets Is Working', props<{ isWorking: boolean }>());
export const setClosestCountIsWorking = createAction(
  '[Impacted Assets] Set Closest Assets Count Is Working',
  props<{ isWorking: boolean }>()
);
export const addSelectedDocumentAssetsSummary = createAction(
  '[Impacted Assets] Add Items to Selected Document Assets Summary',
  props<{ assetsByDistance: DocumentSummaryByLayer[] }>()
);
export const clearSelectedDocumentAssetsSummary = createAction('[Impacted Assets] Clear Selected Document Assets Summary');
export const clearEmailData = createAction('[Impacted Assets] Clear Asset Emails');
export const setSelectionEmailMeta = createAction(
  '[Impacted Assets] Set Email Meta For Selection Communications',
  props<{ selectionFilterDto: ClosestAssetFilterDto }>()
);
export const setAssetEmailsExist = createAction(
  '[Impacted Assets] Set Email Exists For Closest Assets Communications',
  props<{ doEmailsExist: boolean }>()
);
export const getAssetEmails = createAction('[Impacted Assets]  Get Asset Emails');
export const setAssetEmailSummary = createAction('[Impacted Assets] Set Emails Summary From Closest Assets', props<{ docs: Document[] }>());
export const setAssetEmailSummaryComplete = createAction(
  '[Impacted Assets] Set Emails Summary From Closest Assets Complete',
  props<{ emailSummaries: DocumentSummaryWithEmail[] }>()
);
export const setCommunicationMeta = createAction(
  '[Impacted Assets] Set Communication Dialog Meta For Display',
  props<{ isDrawn: boolean; metersWithin: number }>()
);
export const setAssetEmailIsWorking = createAction(
  '[Impacted Assets] Set Closest Assets Emails Is Working',
  props<{ isWorking: boolean }>()
);
export const showHideAssetsRSDView = createAction('[Impacted Assets] Show Hide Assets in RSD Takeover View', props<{ show: boolean }>());
export const loadRemainingClosestAssets = createAction('[Impacted Assets] Load remaining closest assets for display');
export const setClosestAssetDropdownValue = createAction('[Impacted Assets] Set Closest Asset Dropdown Value', props<{ val: number }>());

export const refreshImpactedAssetsByLayerDisplay = createAction('[Impacted Assets] Refresh Impacted Assets by Layer Display');
export const setSelectedDocumentAssetsByDistance = createAction(
  '[Impacted Assets] Set Selected Document Assets By Distance',
  props<{ selectedDocumentAssetsByDistance: DocumentSummaryByLayer[] }>()
);
